import React from "react";
import {
  aidePolyvalente,
  checkIconRed,
  companieSvg,
  courseSvg,
  gardeNuitSvg,
  laptopSvg,
  menageSvg,
} from "../../../../assets/images/Icon";
import {
  CheckIconStyled,
  GridContainer,
  GridItem,
  StyledServiceSVG,
} from "../styled";
// import laptopSvg from "../../../../assets/images/Icon/laptop-icon.svg";

const Service = ({ data, setData }) => {
  const services = [
    {
      label: "INFORMATIQUE ET ADMINISTRATIF",
      icon: laptopSvg,
    },
    {
      label: "MENAGE ET REPASSAGE",
      icon: menageSvg,
    },
    {
      label: "GARDE DE NUIT OU TOILETTES",
      icon: gardeNuitSvg,
    },
    {
      label: "COMPAGNIE ET LOISIRS",
      icon: companieSvg,
    },
    {
      label: "COURSES ET AIDE AU REPAS",
      icon: courseSvg,
    },
    {
      label: "AIDE POLYVALENTE",
      icon: aidePolyvalente,
    },
  ];

  const handleClick = (item) => {
    let cat = data.categorie;
    if (!data.categorie.includes(item.label)) {
      cat.push(item.label);
    } else {
      cat = cat.filter((elem) => !elem.includes(item.label));
    }
    setData({ ...data, categorie: [...cat] });
  };

  return (
    <GridContainer>
      {services.map((item, index) => (
        <GridItem
          selected={data.categorie.includes(item.label)}
          style={{ cursor: "pointer" }}
          onClick={() => {
            handleClick(item);
          }}
          key={index}
        >
          {data.categorie.includes(item.label) && (
            <CheckIconStyled src={checkIconRed} />
          )}
          <StyledServiceSVG src={item.icon} alt={item.label} />
          {item.label}
        </GridItem>
      ))}
    </GridContainer>
  );
};

export default Service;
